import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const STORAGE_KEY = "soiin_auth";

export function getStoredAuth() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setStoredAuth(data) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

export function clearStoredAuth() {
  localStorage.removeItem(STORAGE_KEY);
}

export const apiClient = axios.create({
  baseURL: API,
  timeout: 30000,
});

apiClient.interceptors.request.use((config) => {
  const auth = getStoredAuth();
  if (auth?.access_token) {
    config.headers.Authorization = `Bearer ${auth.access_token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (resp) => resp,
  (error) => {
    if (error.response?.status === 401) {
      clearStoredAuth();
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    // Normalize non-JSON gateway errors (Cloudflare HTML 502/504 etc)
    if (error.response && typeof error.response.data === "string") {
      const status = error.response.status;
      if (status === 502 || status === 504) {
        error.response.data = {
          detail: "Servidor demorou demais para responder (gateway timeout). O processo pode continuar em segundo plano — atualize a página em alguns instantes.",
        };
      } else if (error.response.data.includes("<!DOCTYPE") || error.response.data.includes("<html")) {
        error.response.data = {
          detail: `Erro ${status} do servidor. Tente novamente em instantes.`,
        };
      }
    }
    return Promise.reject(error);
  },
);
